// extracted by mini-css-extract-plugin
module.exports = {"butonShare_container":"styles_butonShare_container__A7xA_"};